<template>
  <b-container class="ricerca">

    <loading :active.sync="loading" 
      :can-cancel="false"
      :is-full-page="true"></loading>


    <Menu></Menu>

    <b-row class="mt-5">
      <b-col sm="12">
          <h3>Ricerca fra le massime presenti</h3>
      </b-col>
      <b-col sm="12" class="pt-4">
          <b-input-group class="px-md-5 px-sm-0">
              <b-form-input 
                  id="input-query"
                  class="text-center"
                  v-model="form.query"
                  @keyup.enter.prevent="searchNew()"
                  placeholder="Cerca una massima..."></b-form-input>
              <b-input-group-append>
                  <b-button variant="outline-primary" @click.prevent="searchNew()">
                      <font-awesome-icon icon="search" />
                  </b-button>
              </b-input-group-append>
          </b-input-group>
      </b-col>
    </b-row>
    <b-row class="mt-3 px-md-5 px-sm-0">
      <b-col sm="3">
        <label for="materia">MATERIA:</label>
      </b-col>
      <b-col sm="3">
        <b-form-select id="materia_1" :options="data.materie1" @change="changeMateria1" v-model="filterMaterie.liv1">
          <template v-slot:first>
            <option :value="``">Qualsiasi</option>
          </template>
        </b-form-select>
      </b-col>
      <b-col sm="3">
        <b-form-select id="materia_2" :options="data.materie2" @change="changeMateria2" v-model="filterMaterie.liv2">
          <template v-slot:first>
            <option :value="``">Qualsiasi</option>
          </template>
        </b-form-select>
      </b-col>
      <b-col sm="3">
        <b-input-group>
          <b-input-group-prepend>
            <b-input-group-text>
              <font-awesome-icon icon="book" />
            </b-input-group-text>
          </b-input-group-prepend>
          <b-form-select id="materia" :options="data.materie" v-model="form.materia">
            <template v-slot:first>
              <option :value="``">Qualsiasi</option>
            </template>
          </b-form-select>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
          <h4 v-if="records && !records.length">Nessun risultato trovato!</h4>
          <b-list-group v-if="records">
              <premassima v-for="result in records" :key="result.id" :premassima="result">
              </premassima>
              
              <infinite-loading @infinite="infiniteHandler" ref="infiniteLoading">
                  <div slot="no-more"></div>
                  <div slot="no-results"></div>
              </infinite-loading>
          </b-list-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import InfiniteLoading from 'vue-infinite-loading';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import api from '../../services/service.js'
import searchApi from '../../services/search.js'
import utils from '../../services/utils.js';

import Premassima from './Premassima.vue'
import Menu from './Menu.vue'

export default {
  name: 'ricerca',
  components: {
    Loading,
    InfiniteLoading,
    Premassima,
    Menu
  },
  data () {
    return {
        loading: false,
        records: null,
        form: {
          query: '',
          materia: '',
          page: 1
        },
        data: {
          materie: [],
          materie1: [],
          materie2: [],
        },
        filterMaterie: {
          liv1: '',
          liv2: ''
        }
    }
  },
  methods: {
    async searchNew() {
      this.form.page = 1;
      this.records = [];

      await this.search();
      if(this.$refs.infiniteLoading) {
        this.$refs.infiniteLoading.stateChanger.reset(); 
      }
    },
    async search() {
      this.loading = true;
      let data = [];

      try {
        let url = 'commento?' + api.encodeQueryData(this.form);
        data = await api.execute('get', url);
      }
      catch(e) {
        alert("Errore durante la ricerca!");
      }

      this.records.push(...data);

      this.form.page += 1;
      this.loading = false;
      return data.length;
    },
    infiniteHandler($state) {
      if(this.records.length) {
        this.search().then((res) => {
          if(res) {
            $state.loaded();
          } else {
            $state.complete();
          }
        });
      }
      else {
        $state.complete();
      }
    },
    changeMateria1(value) {
      searchApi.getMaterie(this.filterMaterie).then((data) => {
        this.data.materie2 = data;
      });
    },
    changeMateria2(value) {
      searchApi.getMaterie(this.filterMaterie).then((data) => {
        this.data.materie = data;
      });
    },
  },
  async created() {
    console.log("test")
    await api.execute('get', 'oauth')
    console.log("test")
    let data = await searchApi.getMaterie(this.filterMaterie);
    this.data.materie1 = data;

    this.$parent._data.loaded = true;
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pubblica/Ricerca.vue